interface FlashProps {
  flash: string | undefined;
  ifDisplayed?: () => void;
}

export function Flash({ flash, ifDisplayed }: FlashProps) {
  if (!flash) return null;
  if (ifDisplayed) {
    ifDisplayed();
  }
  return (
    <div className="mb-4 block w-full rounded-lg bg-blue-100 p-4 text-sm text-blue-700">
      {flash}
    </div>
  );
}
